import styled from 'styled-components';

export const DashboardCard = styled.section<{ $muted?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  border: 1px solid var(--line-gray);
  border-radius: 10px;
  background: ${({ $muted }) => ($muted ? 'var(--background-gray-light)' : 'var(--white)')};
`;

export const SectionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  color: var(--text-primary);
  font-family: var(--font-bold);
  font-size: 20px;
`;

export const SectionDescription = styled.div`
  color: var(--text-secondary);
  font-size: 14px;
`;

export const SubsectionTitle = styled.div`
  color: var(--text-primary);
  font-family: var(--font-bold);
  font-size: 16px;
`;

export const EmptySection = styled.div`
  padding: 20px;
  border: 1px solid var(--line-gray);
  border-radius: 6px;
  color: var(--text-secondary);
  font-size: 14px;
`;

export const CommunityName = styled.div`
  color: var(--text-primary);
  font-family: var(--font-bold);
  font-size: 13px;
`;

export const CommunityMeta = styled.div`
  margin-top: 2px;
  color: var(--text-secondary);
  font-size: 12px;
`;
